import I18n from 'I18n';
export const getConversationTypeName = channel => {
  switch (channel) {
    case 'EMAIL':
      return I18n.text('customer-portal-app.conversationTypes.email');
    case 'LIVE_CHAT':
      return I18n.text('customer-portal-app.conversationTypes.liveChat');
    case 'FORMS':
      return I18n.text('customer-portal-app.conversationTypes.forms');
    case 'CUSTOMER_PORTAL_THREAD_VIEW':
      return I18n.text('customer-portal-app.conversationTypes.customerPortal');
    default:
      return I18n.text('customer-portal-app.conversationTypes.other');
  }
};